// extracted by mini-css-extract-plugin
export default {"title":"text_title__QQWaS","text__title":"text_text__title__D1hBE","module":"text_module__jiKgE","text":"text_text__cbVPr","loader":"text_loader__8ltLF"};